import { Flex, Input } from "antd";
import React from "react";

const PasswordInput = ({
  placeholder = "-",
  title,
  value,
  onChange,
  onKeyDown,
  autoFocus = false,
  prefix,
  suffix,
  style,
  required,
}) => {
  return (
    <Flex vertical gap={"2px"} style={{ width: "100%" }}>
      {title && (
        <p style={{ fontSize: "13px" }}>
          {required && <span style={{ color: "#f00" }}>*</span>}
          {title}:
        </p>
      )}
      <Input.Password
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        autoFocus={autoFocus}
        prefix={prefix}
        suffix={suffix}
        style={{ ...style, minHeight: "40px" }}
      />
    </Flex>
  );
};

export default PasswordInput;
